// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.donate-layout {
  display: flex;
  gap: 40px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.donate-panel {
  flex: 1 1 260px;
  background-color: var(--surface-raised);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-soft);
  padding: 32px;
}

.donate-side {
  flex: 1 1 300px;
  background-color: var(--surface-sunken);
  border-radius: var(--radius-lg);
  padding: 32px;
}

.donate-side p {
  margin: 0 0 16px;
}

.donate-side strong {
  color: var(--text-primary);
}

.donate-side h3 {
  margin-bottom: 16px;
}

.donate-side ul {
  padding-left: 20px;
  margin: 0 0 20px;
}

.donate-side li {
  margin-bottom: 12px;
}

.donate-side-note {
  font-size: 0.9rem;
  opacity: 0.85;
  margin-bottom: 0;
}

/* Phones: the page margin plus 32px of card padding left the Givebutter form
   and the text only ~280px of a 390px screen. The form has its own internal
   spacing, so its card needs almost none here. */
@media (max-width: 600px) {
  .donate-layout {
    gap: 40px;
  }

  .donate > section:not(.feature-header) {
    padding-top: 8px;
  }

  /* Extra room under the form so it doesn't end flush with the card. */
  .donate-panel {
    padding: 8px 8px 24px;
  }

  .donate-side {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Donate.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA,qEAAqE;EACrE;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".donate-layout {\n  display: flex;\n  gap: 40px;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.donate-panel {\n  flex: 1 1 260px;\n  background-color: var(--surface-raised);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-soft);\n  padding: 32px;\n}\n\n.donate-side {\n  flex: 1 1 300px;\n  background-color: var(--surface-sunken);\n  border-radius: var(--radius-lg);\n  padding: 32px;\n}\n\n.donate-side p {\n  margin: 0 0 16px;\n}\n\n.donate-side strong {\n  color: var(--text-primary);\n}\n\n.donate-side h3 {\n  margin-bottom: 16px;\n}\n\n.donate-side ul {\n  padding-left: 20px;\n  margin: 0 0 20px;\n}\n\n.donate-side li {\n  margin-bottom: 12px;\n}\n\n.donate-side-note {\n  font-size: 0.9rem;\n  opacity: 0.85;\n  margin-bottom: 0;\n}\n\n/* Phones: the page margin plus 32px of card padding left the Givebutter form\n   and the text only ~280px of a 390px screen. The form has its own internal\n   spacing, so its card needs almost none here. */\n@media (max-width: 600px) {\n  .donate-layout {\n    gap: 40px;\n  }\n\n  .donate > section:not(.feature-header) {\n    padding-top: 8px;\n  }\n\n  /* Extra room under the form so it doesn't end flush with the card. */\n  .donate-panel {\n    padding: 8px 8px 24px;\n  }\n\n  .donate-side {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
